export enum typeBannerHotel {
  BANNER = 'banner',
  HIGHLIGHT = 'highlight',
}
interface CreateAgregatorPublicityDto {
  image: string | File
  aggregatorClassificationId: number
  pluginSpaceAggregatorId: number | null
  order: number
  title: string
  type: typeBannerHotel
  startDate: string
  endDate: string
  description: string
  externalLink: string
  status: boolean
  labelButton: string | null
}
interface UpdateAgregatorPublicityDto {
  image: string | File
  aggregatorClassificationId: number
  pluginSpaceAggregatorId: number | null
  order: number
  title: string
  type: typeBannerHotel
  startDate: string
  endDate: string
  description: string
  externalLink: string
  status: boolean
  labelButton: string | null
}

interface AggregatorPublicity {
  id: number
  pluginspaceId: number
  image: string
  title: string
  type: typeBannerHotel
  order: number
  startDate: string
  endDate: string
  status: boolean
  description: string
  externalLink?: string
  created: string
  updated: string
  labelButton?: string
}


export type { CreateAgregatorPublicityDto, AggregatorPublicity, UpdateAgregatorPublicityDto }